
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/axalogin.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { Page } from '@helpers/types';
import LoginLayout from '@components/Layouts/Login';
import RestrictedAccessView from '@components/Login/views/RestrictedAccessView';

const AxaLogin: Page = () => (
  <LoginLayout>
    <RestrictedAccessView />
  </LoginLayout>
);


export const Route = createFileRoute('/axalogin')({ component: AxaLogin });
